import { useEffect, useRef, useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Input, Row } from 'reactstrap';
import { applicantProfileService } from '../../services';
import styles from './Comment.module.scss';
import { ApplicantActions } from '../../actions/applicant.actions';
import parse from 'html-react-parser';
import { CgAttachment } from 'react-icons/cg';
import { IoMdSend } from 'react-icons/io';
import { AiOutlineClose, AiOutlineDownload } from 'react-icons/ai';
import ActionMenu from '../../components/common/ActionMenu/ActionMenu';
import ConfirmDialog from '../common/ConfirmDialog/ConfirmDialog';
import useModal from '../Hooks/useModal';
import { BsExclamation } from 'react-icons/bs';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useOuterClick } from '../../helpers';
import DropdownMenuComponent from '../common/ActionMenu/DropDownMenu';
import { VscPreview } from 'react-icons/vsc';
import { toast } from 'react-toastify';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from 'draft-convert';
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import globeIcon from "../../resources/images/globe.svg"
import multiUserIcon from "../../resources/images/multipleUsers.svg"
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const CommentPage = (props) => {
  const editorRef = useRef(null);

  const [messageInput, setMessageInput] = useState('');
  let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
  let { toggle: FileSizeUploadToggle, visible: FileSizeUploadModal } =
    useModal();
  let { toggle: EditTextUploadToggle, visible: EditTextUploadModal } =
    useModal();
  const [suggestionLst, setSuggestionLst] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilepath, setUploadedFilepath] = useState([]);

  const [mentionId, setMentionId] = useState([]);
  const [removeFile, setRemoveFile] = useState([]);

  //Use state for Edit comments
  const [editedInput, setEditedInput] = useState('');
  const [editSelComment, setEditSelComment] = useState('');
  const [editedMentionId, setEditedMentionId] = useState([]);
  const [selectedCID, setSelectedCID] = useState(null);
  const [editUploadedFiles, setEditUploadedFiles] = useState([]);
  const [editUploadedFilepath, setEditUploadedFilepath] = useState([]);
  const [removeOldFile, setRemoveOldFile] = useState([]);
  const [editAttachmentList, setEditAttachmentList] = useState([]);

  const [deleteId, setDeleteId] = useState(null);
  const [fileSizeLimit, setFileSizeLimit] = useState();
  const [editTextUpload, setEditTextUpload] = useState();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const location = useLocation();
  const user = useSelector((state) => state.authentication.user);
  const userProfile = useSelector((state) => state.authentication.userProfile);
  const editImageData = useSelector((state) => state.applicant.commentData);
  const commentData = useSelector((state) => state.applicant.commentData);
  const [visible, setVisible] = useState('Visibility Limited');

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [editEditorState, setEditEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    if (props?.cloneJob && props.selectedId != "" && props?.callSendComment) {
      sendComment()
      props?.setCallSendComment(false)
    }
  }, [props?.callSendComment]);


  useEffect(() => {
    let html = convertToHTML(editorState.getCurrentContent());
    setMessageInput(html);
  }, [editorState]);

  useEffect(() => {
    let html = convertToHTML(editEditorState.getCurrentContent());
    setEditedInput(html);
  }, [editEditorState]);

  const htmlToDraftBlocks = (html) => {
    const blocksFromHtml = htmlToDraft(html);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const editorState = EditorState.createWithContent(contentState);

    return editorState;
  };

  useEffect(() => {
    if (searchParams.get('commentId')) {
      if (searchParams.get('commentId')) {
        setSelectedCID(parseInt(searchParams.get('commentId')));
      } else {
        setSelectedCID(null);
      }
    } else {
      if (
        location?.state &&
        location?.state?.commentId &&
        location?.state?.commentId !== null
      ) {
        setSelectedCID(location?.state?.commentId);
      }
    }
  }, [location?.state]);

  const selElement = document.getElementById('selectedComment');
  useEffect(() => {
    scrollToCommentDiv();
  }, [selElement, selectedCID, commentData]);

  useEffect(() => {
    if (deleteId !== null) {
      ConfirmToggle();
    }
  }, [deleteId]);

  useEffect(() => {
    if (fileSizeLimit) {
      FileSizeUploadToggle();
    }
  }, [fileSizeLimit]);

  useEffect(() => {
    if (!FileSizeUploadModal) {
      setFileSizeLimit(false);
    }
  }, [FileSizeUploadModal]);

  useEffect(() => {
    if (editTextUpload) {
      EditTextUploadToggle();
    }
  }, [editTextUpload]);

  useEffect(() => {
    if (!editTextUpload) {
      setEditTextUpload(false);
    }
  }, [editTextUpload]);

  useEffect(() => {
    applicantProfileService.getMentaionUsers('').then((res) => {
      let userMentionData = res.map((myUser) => ({
        id: myUser.id,
        display: myUser.full_name,
        text: myUser.full_name,
        value: myUser.full_name,
        url: myUser.id,
      }));
      props.announcementTab
        ? setSuggestionLst([
            {
              id: 0,
              display: 'Everyone',
              text: 'Everyone',
              value: 'Everyone',
              url: 0,
            },
            ...userMentionData,
          ])
        : setSuggestionLst(userMentionData);
    });
  }, []);

  useEffect(() => {
    setEditAttachmentList();
  }, [editSelComment]);

  const deleteComment = (id) => {
    if (id) {
      dispatch(ApplicantActions.deleteComment(id));
      setDeleteId(null);
      ConfirmToggle();
    }
  };

  const handleTextAreaChange = (RawDraftContentState) => {
    let mentionsId = [];

    for (const key in RawDraftContentState.entityMap) {
      mentionsId.push(RawDraftContentState.entityMap[key].data.url);
    }

    setMentionId(mentionsId);
  };

  const renderSuggestion = (
    suggestion,
    search,
    highlightedDisplay,
    index,
    focused
  ) => {
    // const data = messageInput.replace(/[^a-zA-Z ]/g, "");
    // const mentions = data.split(" ");

    // console.log(data)

    return (
      <div className={styles.suggestion}>
        <Avatar
          name={
            suggestion?.display.split(' ')[0] +
            suggestion?.display.split(' '[1])
          }
          size='30'
          round={true}
          style={{ fontSize: 20, marginRight: '.8rem' }}
          user={suggestion.user}
        />
        <span className={styles.title}>{highlightedDisplay}</span>
      </div>
    );
  };

  const handleEditedTextAreaChange = (RawDraftContentState) => {
    let editMentionsId = [];

    for (const key in RawDraftContentState.entityMap) {
      editMentionsId.push(RawDraftContentState.entityMap[key].data.url);
    }

    RawDraftContentState.blocks.forEach((ele) => {
      if (ele.text.includes('@')) {
        let textArr = ele.text.split('@');
        commentData.forEach((data) => {
          if (data.id === editSelComment) {
            data.mentions.forEach((men) => {
              textArr.forEach((text) => {
                if (
                  text.trim() === men.name &&
                  !editMentionsId.includes(men.resourceId)
                ) {
                  editMentionsId.push(men.resourceId);
                }
              });
            });
          }
        });
      }
    });
    setEditedMentionId(editMentionsId);
  };

  // const filterUserFn = (e) => {
  //   if (e.target.value.includes("@")) {
  //     let result = /[^@]*$/.exec(e.target.value)[0];
  //     let checkStr = result.split(" ");
  //     if (checkStr.length === 1) {
  //       applicantProfileService
  //         .getMentaionUsers(result.toLowerCase())
  //         .then((res) => {
  //           setSuggestionLst(res);
  //           // needed code
  //           //let finalRes = [];
  //           // if (mentionId.length > 0) {
  //           //   res.forEach((val) => {
  //           //     if (!mentionId.includes(val.id)) {
  //           //       finalRes.push(val);
  //           //     }
  //           //   });
  //           // } else {
  //           //   finalRes = res;
  //           // }
  //           // setSuggestionLst(finalRes);
  //           // console.log(mentionId);

  //           let editCommentText = e.target.value.split('@');
  //           let mentionIdsLocal = []
  //           editCommentText.forEach((text) => {
  //             res.forEach((val) => {
  //               if(val.full_name === text) {
  //                 mentionIdsLocal.push(val.id);
  //               }
  //             })
  //           })
  //           setMentionId([...mentionId, ...mentionIdsLocal])
  //           console.log(mentionIdsLocal);
  //         });
  //     }
  //   } else {
  //     setSuggestionLst([]);
  //   }
  //   if (e.target.value === "") {
  //     setSuggestionLst([]);
  //   }
  // };

  function scrollToCommentDiv() {
    const divElement = document.getElementById('selectedComment');
    if (divElement) {
      divElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handleUploadFiles = (files) => {
    if (editSelComment) {
      const uploaded = [...editUploadedFiles];
      files.some((file) => {
        if (uploaded.findIndex((f) => f.name === file.name) === -1) {
          uploaded.push(file);
        }
      });
      setEditUploadedFiles(uploaded);
    } else {
      const uploaded = [...uploadedFiles];
      files.some((file) => {
        if (uploaded.findIndex((f) => f.name === file.name) === -1) {
          uploaded.push(file);
        }
      });

      setUploadedFiles(uploaded);
    }
  };

  const handleFileEvent = async (e) => {
    let validImage = true;
    if (editSelComment) {
      Object.entries(e.target.files).map(([key, value], index) => {
        editImageData
          .find((obj) => obj.id == editSelComment)
          .attachment.map((image) => {
            if (image.name.substring(14) == value.name) {
              validImage = false;
            }
          });
      });
    }
    if (!validImage) {
      toast.error('Duplicate files not allowed');
    }

    if (validImage) {
      const chosenFiles = Array.prototype.slice.call(e.target.files);
      if (chosenFiles && chosenFiles.length > 0) {
        for (let i = 0; i < chosenFiles.length; i++) {
          if (chosenFiles[i]?.size > 5000000) {
            setFileSizeLimit(true);
            return;
          }
        }

        if (!fileSizeLimit) {
          handleUploadFiles(chosenFiles);
          handleUrlPath(e);
        }
      }
    }
  };

  const handleUrlPath = (e) => {
    for (const file of e.target.files) {
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (editSelComment) {
            setEditUploadedFilepath((editUploadedFilepath) => [
              ...editUploadedFilepath,
              reader.result,
            ]);
          } else {
            setUploadedFilepath((uploadedFilepath) => [
              ...uploadedFilepath,
              reader.result,
            ]);
          }
        };
      } else if (file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/zip') {
        const newFiles = [];
        newFiles.push(file);
        if (editSelComment) {
          setEditUploadedFilepath((prev) => {
            return [...prev, ...newFiles];
          });
        } else {
          setUploadedFilepath((prev) => {
            return [...prev, ...newFiles];
          });
        }
      }
    }
  };

  const removeAttachment = (index) => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      const uparr = [...uploadedFilepath];
      const uploaded = [...uploadedFiles];
      uparr.splice(index, 1);
      uploaded.splice(index, 1);
      setUploadedFiles(uploaded);
      setUploadedFilepath(uparr);
    }
  };

  const removeEditAttachment = (type, fileId) => {
    if (type === 'new') {
      if (editUploadedFiles && editUploadedFiles.length > 0) {
        const uparr = [...editUploadedFilepath];
        const uploaded = [...editUploadedFiles];
        uparr.splice(fileId, 1);
        uploaded.splice(fileId, 1);
        setEditUploadedFiles(uploaded);
        setEditUploadedFilepath(uparr);
      }
    } else if (type === 'old') {
      const arrRem = [];
      arrRem.push(fileId);
      if (removeOldFile && removeOldFile.length > 0) {
        setRemoveOldFile((prev) => [...prev, ...arrRem]);
      } else {
        setRemoveOldFile([fileId]);
      }

      const arr = removeFile;
      if (removeFile && removeFile.length > 0) {
        arr.push(fileId);
        setRemoveFile(arr);
      } else {
        setRemoveFile([fileId]);
      }
    }
  };

  const sendComment = () => {
    const req = {
      selectedId: props?.selectedId
    };
    if (
      messageInput.replace('<p></p>', '') ||
      (uploadedFiles && uploadedFiles.length > 0)
    ) {
      //Add commentFile
      if (
        (props?.selectedId && messageInput.length > 0) ||
        (uploadedFiles && uploadedFiles.length > 0)
      ) {
        var form_data = new FormData();
        form_data.append(
          props?.announcementTab ? 'jobId' : 'jobAppId',
          props?.selectedId
        );
        form_data.append('isPrivate', (visible === 'Visibility Limited' ? true : false));
        form_data.append('message', messageInput);
        form_data.append('mentionId', mentionId.join(','));
        if (uploadedFiles && uploadedFiles.length > 0) {
          for (let i = 0; i < uploadedFiles.length; i++) {
            form_data.append('commentFile', uploadedFiles[i]);
          }
        }

        dispatch(
          props?.announcementTab
            ? ApplicantActions.announcementCreateComment(form_data)
            : ApplicantActions.createComment(form_data, req)
        );
        setMentionId([]);
        setMessageInput('');
        setUploadedFiles([]);
        setEditorState(EditorState.createEmpty());
        setUploadedFilepath([]);
      }
      // dispatch(ApplicantActions.getComment(props?.selectedId));
    } else if (
      editedInput.replace('<p></p>', '') ||
      (editUploadedFiles && editUploadedFiles.length > 0)
    ) {
      var form_data = new FormData();
      form_data.append(
        props?.announcementTab ? 'jobId' : 'jobAppId',
        props?.selectedId
      );
      const combinedMentionId = [...mentionId, ...editedMentionId];
      form_data.append('message', editedInput);
      form_data.append('mentionId', combinedMentionId.join(','));
      form_data.append('removeFile', removeFile.join(','));
      if (editUploadedFiles && editUploadedFiles.length > 0) {
        for (let i = 0; i < editUploadedFiles.length; i++) {
          form_data.append('commentFile', editUploadedFiles[i]);
        }
      }
      dispatch(ApplicantActions.editComment(form_data, editSelComment)).then(
        () => {
          [];
          setEditedMentionId([]);
          setEditSelComment(null);
          setEditedInput('');
          setEditUploadedFiles([]);
          setEditUploadedFilepath([]);
          setRemoveFile([]);
          setEditEditorState(EditorState.createEmpty());
        }
      );
      // dispatch(ApplicantActions.getComment(props?.selectedId));
    } else {
      setEditTextUpload(true);
    }
  };

  const commentAttechment = () => {
    const input = document.getElementById('file-input');
    if (input) {
      input.click();
    }
  };

  const handleItemClick = (value) => {
    setVisible(value);
    const dropdownButton = document.querySelector('.dropdown');
    dropdownButton?.click();
  };


  return (
    <div className={styles.CommentMain}>
      <Container>
        <div className={styles.CommentInput}>
          <div className={styles.avtarPart}>
            {userProfile && userProfile?.resource?.avtar?.url ? (
              <Avatar
                className={styles.commentAvt}
                facebook-id='invalidfacebookusername'
                src={userProfile?.resource?.avtar?.url}
                size='30'
                round={true}
              />
            ) : (
              <Avatar
                className={styles.commentAvt}
                name={
                  user && user?.name.split(' ')[0] + user?.name.split(' '[1])
                }
                size='30'
                round={true}
              />
            )}
          </div>

          <div className={styles.textInputComment}>
            <Editor
              toolbarHidden={props?.cloneJob ? true : false} 
              onChange={handleTextAreaChange}
              editorState={editorState}
              onEditorStateChange={setEditorState}
              wrapperClassName='wrapper-class'
              editorClassName='editor-class'
              toolbarClassName='toolbar-class'
              mention={{
                separator: ' ',
                trigger: '@',
                suggestions: suggestionLst,
              }}
            />
            <div className={styles.iconPart}>
            {(!props?.announcementTab && user?.userRole !== 4)&& 
              <div className="dropdown">
                <button className={`${styles.visibleDropdownBtn} dropdown-toggle`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {visible}
                </button>
                <ul className={`${styles.dropdownMenu} dropdown-menu`}>
                  <li><a className={`${styles.dropdownItem} dropdown-item`}  onClick={() => handleItemClick('Visibility Limited')}>Visibility Limited</a></li>
                  <li><a className={`${styles.dropdownItem} dropdown-item`}  onClick={() => handleItemClick('Visibility All')}>Visibility All</a></li>
                </ul>
              </div>}
              <CgAttachment
                onClick={() => {
                  commentAttechment(), setEditSelComment(false);
                }}
              />
              <input
                type='file'
                multiple
                id='file-input'
                onChange={handleFileEvent}
                style={{ display: 'none' }}
                onClick={(e) => {
                  e.target.value = null;
                }}
              />
              {
                !props?.cloneJob &&  <IoMdSend onClick={() => sendComment()} />
              }             
            </div>
          </div>
        </div>
        {
          !props?.cloneJob &&
          <div className={styles.attachmentMainPart}>
            <Row className={styles.attachmentPart}>
              {uploadedFilepath &&
                uploadedFilepath.map((data, index) => {
                  return (
                    <>
                      {data?.type !== 'application/pdf' && (
                        <Col md='2' xs='6'>
                          <div className={styles.attachmentImage}>
                            <div className={styles.imageCard}>
                              <img src={data} alt='Files' />
                            </div>
                            <AiOutlineClose
                              className={styles.closeBtnPart}
                              onClick={() => removeAttachment(index)}
                            />
                          </div>
                        </Col>
                      )}
                    </>
                  );
                })}
            </Row>

            <Row className={styles.attachmentPart}>
              {uploadedFilepath &&
                uploadedFilepath.map((data, index) => {
                  return (
                    <>
                      {data?.type === 'application/pdf' && (
                        <Col md='2' xs='6'>
                          <div className={styles.attechmentChip}>
                            {data?.name.length > 10
                              ? data?.name.substring(0, 12) + ' ...'
                              : data?.name}
                            <AiOutlineClose
                              className={styles.closeBtnPart}
                              onClick={() => removeAttachment(index)}
                            />
                          </div>
                        </Col>
                      )}
                    </>
                  );
                })}
            </Row>
          </div>
        }
        

        {/* {messageInput && suggestionLst.length > 0 && (
          <div className={styles.suggestions}>
            {suggestionLst.map((users, index) => {
              return (
                <div
                  onMouseEnter={() => {
                    setActiveSag(index);
                  }}
                  onMouseLeave={() => {
                    setActiveSag(0);
                  }}
                  key={index}
                  className={`${styles.sNames} ${activeSag === index ? styles.activeList + " activeTag" : ""
                    } `}
                  onClick={() => {
                    var afterWith = messageInput.substr(
                      0,
                      messageInput.lastIndexOf("@") + 1
                    );
                    if (mentionId.length > 0) {
                      let arr = mentionId;
                      if (!arr.includes(users.id)) {
                        arr.push(users.id);
                      }
                      setMentionId(arr);
                    } else {
                      setMentionId([users.id]);
                    }
                    setSuggestionLst([]);
                    setMessageInput(`${afterWith}${users?.full_name}`);
                  }}
                >
                  {users?.avtar && users?.avtar?.url ?
                    <Avatar
                    facebook-id="invalidfacebookusername"
                      src={users?.avtar?.url}
                      size="30"
                      round={true}
                      style={{ fontSize: 20 }}
                    /> : <Avatar
                      name={users?.full_name.split(" ")[0]}
                      size="30"
                      round={true}
                      style={{ fontSize: 20 }}
                    />
                  }

                  <span style={{ padding: 8 }}>{users?.full_name} </span>
                </div>
              );
            })}
          </div>
        )} */}
        {
          !props?.cloneJob &&
          <div className={styles.commentMainPart}>
          {commentData && commentData.length > 0
            ? commentData.map((val, i) => (
                <Row
                  className={`${styles.commentRow} ${
                    selectedCID !== null && selectedCID === val?.id
                      ? styles.selectedComment
                      : ''
                  }`}
                  id={
                    selectedCID === val?.id
                      ? 'selectedComment'
                      : `comment_${val?.id}`
                  }
                >
                  <Col md='8' sm='12'>
                    <div className={styles.commentLeft}>
                      <div className={styles.avtarPart}>
                        {val?.created_by?.avtar &&
                        val?.created_by?.avtar?.url ? (
                          <Avatar
                            className={styles.commentAvt}
                            facebook-id='invalidfacebookusername'
                            src={val?.created_by?.avtar?.url}
                            size='30'
                            round={true}
                          />
                        ) : (
                          <Avatar
                            className={styles.commentAvt}
                            name={
                              val?.created_by?.name +
                              ' ' +
                              val?.created_by?.lastName
                            }
                            maxInitials={2}
                            size='30'
                            round={true}
                          />
                        )}
                      </div>
                      <div className={styles.commentTitlePart}>
                        {val?.created_by?.name}{' '}
                        {val?.created_by?.lastName != null
                          ? val?.created_by?.lastName
                          : ''}{' '}
                        |{' '}
                        <span className={styles.commentInner}>
                          {val?.applicant_note}
                        </span>
                        {(!props?.announcementTab && user?.userRole !== 4) && 
                          <span className='px-2'>
                            {val?.isPrivate ? 
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-private">Visibility Limited</Tooltip>}
                              >
                                <img width={12} src={multiUserIcon} className="drop-icon" />
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-public">Visibility All</Tooltip>}
                              >
                                <img width={12} src={globeIcon} className="drop-icon" />
                              </OverlayTrigger>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  </Col>
                  <Col md='4' sm='12'>
                    <div className={styles.commentRight}>
                      <div className={styles.commentNote}>{val?.notes}</div>
                      <div>
                        {val?.isEditable ? (
                          <DropdownMenuComponent
                            className='customDropdown'
                            row={val}
                            editSelComment={editSelComment}
                            setUploadedFilepath={setUploadedFilepath}
                            setUploadedFiles={setUploadedFiles}
                            setMessageInput={setMessageInput}
                            setEditUploadedFiles={setEditUploadedFiles}
                            setEditUploadedFilepath={setEditUploadedFilepath}
                            setEditedInput={setEditedInput}
                            setEditSelComment={setEditSelComment}
                            setDeleteId={setDeleteId}
                            setEditEditorState={setEditEditorState}
                            htmlToDraftBlocks={htmlToDraftBlocks}
                            selectedId={props?.selectedId}
                            announcementTab={props?.announcementTab}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col md='12' sm='12'>
                    <div
                      className={`${styles.messagePart} ${styles.editMessagePart}`}
                    >
                      {editSelComment === val?.id ? (
                        <div className={styles.textInputComment}>
                          <Editor
                            onChange={handleEditedTextAreaChange}
                            editorState={editEditorState}
                            onEditorStateChange={setEditEditorState}
                            wrapperClassName='wrapper-class'
                            editorClassName='editor-class'
                            toolbarClassName='toolbar-class'
                            mention={{
                              separator: ' ',
                              trigger: '@',
                              suggestions: suggestionLst,
                            }}
                          />
                          <div className={styles.iconPart}>
                            <AiOutlineClose
                              className={styles.closeBtnPart}
                              onClick={() => {
                                setEditUploadedFilepath([]);
                                setEditUploadedFiles([]);
                                setRemoveFile([]);
                                setRemoveOldFile([]);
                                setEditSelComment(false);
                              }}
                            />
                            <CgAttachment onClick={() => commentAttechment()} />
                            <input
                              type='file'
                              multiple
                              id='file-input'
                              onChange={(e) => handleFileEvent(e)}
                              style={{ display: 'none' }}
                              onClick={(e) => {
                                e.target.value = null;
                              }}
                            />
                            <IoMdSend onClick={() => sendComment()} />
                          </div>
                        </div>
                      ) : (
                        parse(val?.message)
                      )}
                    </div>
                    {val?.attachment ? (
                      <>
                        <Row className={styles.attachmentPart}>
                          {val?.attachment.map((data) => {
                            return (
                              <>
                                {data.isImage ? (
                                  removeOldFile.includes(data.id) ? null : (
                                    <Col
                                      md='2'
                                      xs='6'
                                      className={styles.imageViewer}
                                    >
                                      <a href={data.attachment} download>
                                        <img
                                          className={styles.imageAttachment}
                                          src={data.attachment}
                                          alt={data.name}
                                        />
                                      </a>
                                      <div className={styles.crossIcon}>
                                        {editSelComment === val?.id && (
                                          <AiOutlineClose
                                            className={styles.closeBtnPart}
                                            onClick={() =>
                                              removeEditAttachment(
                                                'old',
                                                data?.id
                                              )
                                            }
                                          />
                                        )}
                                      </div>
                                    </Col>
                                  )
                                ) : null}
                              </>
                            );
                          })}
                          {editSelComment === val?.id &&
                            editUploadedFilepath &&
                            editUploadedFilepath.map((data, index) => {
                              return (
                                <>
                                  {data?.type !== 'application/pdf' && (
                                    <Col
                                      md='2'
                                      xs='6'
                                      className={styles.imageViewer}
                                    >
                                      <img
                                        className={styles.imageAttachment}
                                        src={data}
                                        alt={data.name}
                                      />

                                      <div className={styles.crossIcon}>
                                        <AiOutlineClose
                                          className={styles.closeBtnPart}
                                          onClick={() =>
                                            removeEditAttachment('new', index)
                                          }
                                        />
                                      </div>
                                    </Col>
                                  )}
                                </>
                              );
                            })}
                        </Row>
                        <Row className={styles.attachmentPart}>
                          {val?.attachment.map((data) => {
                            return (
                              <>
                                {data.isImage ? null : removeOldFile.includes(
                                    data.id
                                  ) ? null : (
                                  <Col md='2' xs='6'>
                                    <div className={styles.attechmentChip}>
                                      {data?.name && data?.name.length > 10
                                        ? data?.name.substring(0, 20) + ' ...'
                                        : data?.name}
                                      {editSelComment === val?.id ? (
                                        <AiOutlineClose
                                          className={styles.closeBtnPart}
                                          onClick={() =>
                                            removeEditAttachment(
                                              'old',
                                              data?.id
                                            )
                                          }
                                        />
                                      ) : (
                                        <a
                                          href={data.attachment}
                                          download={data?.name}
                                          target='_blank'
                                        >
                                          {data?.name.includes('.pdf') ? (
                                            <VscPreview
                                              className={styles.downloadPart}
                                            />
                                          ) : (
                                            <AiOutlineDownload
                                              className={styles.downloadPart}
                                            />
                                          )}
                                        </a>
                                      )}
                                    </div>
                                  </Col>
                                )}
                              </>
                            );
                          })}
                          {editSelComment === val?.id &&
                            editUploadedFilepath &&
                            editUploadedFilepath.map((data, index) => {
                              return (
                                <>
                                  {data?.type === 'application/pdf' && (
                                    <Col md='2' xs='6'>
                                      <div className={styles.attechmentChip}>
                                        {data?.name && data?.name.length > 10
                                          ? data?.name.substring(0, 15) + ' ...'
                                          : data?.name}
                                        <AiOutlineClose
                                          className={styles.closeBtnPart}
                                          onClick={() =>
                                            removeEditAttachment('new', index)
                                          }
                                        />
                                      </div>
                                    </Col>
                                    // <Col md="2" xs="6">
                                    //   <div className={styles.attechmentChip}>
                                    //     {data?.name.length > 10
                                    //       ? data?.name.substring(0, 12) + " ..."
                                    //       : data?.name}
                                    //     <AiOutlineClose
                                    //       className={styles.closeBtnPart}
                                    //       onClick={() => removeAttachment(index)}
                                    //     />
                                    //   </div>
                                    // </Col>
                                  )}
                                </>
                              );
                            })}
                        </Row>
                      </>
                    ) : (
                      ''
                    )}
                  </Col>
                  {/* {editSelComment === val?.id && (
                    <div className={styles.attachmentMainPart}>
                      {editedInput !== null &&
                      editedInput?.attachment &&
                      editedInput?.attachment.length > 0 ? (
                        <Row className={styles.attachmentPart}>
                          {editAttachmentList &&
                            editAttachmentList?.map((data) => {
                              return (
                                <>
                                  <Col key={data.id} md="3" xs="6">
                                    <div className={styles.attechmentChip}>
                                      {data?.name.length > 10
                                        ? data?.name.substring(0, 20) + " ..."
                                        : data?.name}
                                      <AiOutlineClose
                                        className={styles.closeBtnPart}
                                        onClick={() =>
                                          removeEditAttachment("old", data?.id)
                                        }
                                      />
                                      1
                                    </div>
                                  </Col>
                                </>
                              );
                            })}
                          {editUploadedFiles &&
                            editUploadedFiles.length > 0 &&
                            editUploadedFiles.map((dt, ind) => {
                              return (
                                <>
                                  <Col md="3" xs="6">
                                    <div className={styles.attechmentChip}>
                                      {dt?.name.length > 10
                                        ? dt?.name.substring(0, 20) + " ..."
                                        : dt?.name}

                                      <AiOutlineClose
                                        className={styles.closeBtnPart}
                                        onClick={() =>
                                          removeEditAttachment("new", ind)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </>
                              );
                            })}
                        </Row>
                      ) : (
                        <Row className={styles.attachmentPart}>
                          {editUploadedFiles &&
                            editUploadedFiles.length > 0 &&
                            editUploadedFiles.map((dt, ind) => {
                              return (
                                <>
                                  <Col md="3" xs="6">
                                    <div className={styles.attechmentChip}>
                                      {dt?.name.length > 10
                                        ? dt?.name.substring(0, 20) + " ..."
                                        : dt?.name}

                                      <AiOutlineClose
                                        className={styles.closeBtnPart}
                                        onClick={() =>
                                          removeEditAttachment("new", ind)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </>
                              );
                            })}
                        </Row>
                      )}
                    </div>
                  )} */}
                  {/* <div className={styles.attachmentMainPart}>
                  {editedData !== null &&
                    editedData?.attachment &&
                    editedData?.attachment.length > 0 ? (
                    <Row className={styles.attachmentPart}>
                      {attechmentList &&
                        attechmentList?.map((data) => {
                          return (
                            <>
                              <Col key={data.id} md="3" xs="6">
                                <div className={styles.attechmentChip}>
                                  {data?.name.length > 10
                                    ? data?.name.substring(0, 20) + " ..."
                                    : data?.name}

                                  <AiOutlineClose
                                    className={styles.closeBtnPart}
                                    onClick={() => removeAttachment("old", data?.id)}
                                  />
                                </div>
                              </Col>
                            </>
                          );
                        })}
                      {uploadedFiles &&
                        uploadedFiles.length > 0 &&
                        uploadedFiles.map((dt, ind) => {
                          return (
                            <>
                              <Col md="3" xs="6">
                                <div className={styles.attechmentChip}>
                                  {dt?.name.length > 10
                                    ? dt?.name.substring(0, 20) + " ..."
                                    : dt?.name}

                                  <AiOutlineClose
                                    className={styles.closeBtnPart}
                                    onClick={() => removeAttachment("new", ind)}
                                  />
                                </div>
                              </Col>
                            </>
                          );
                        })}
                    </Row>
                  ) : (
                    <Row className={styles.attachmentPart}>
                      {uploadedFiles &&
                        uploadedFiles.length > 0 &&
                        uploadedFiles.map((dt, ind) => {
                          return (
                            <>
                              <Col md="3" xs="6">
                                <div className={styles.attechmentChip}>
                                  {dt?.name.length > 10
                                    ? dt?.name.substring(0, 20) + " ..."
                                    : dt?.name}

                                  <AiOutlineClose
                                    className={styles.closeBtnPart}
                                    onClick={() => removeAttachment("new", ind)}
                                  />
                                </div>
                              </Col>
                            </>
                          );
                        })}
                    </Row>
                  )}
                </div> */}
                </Row>
              ))
            : ''}
        </div>
        }
       
      </Container>
      <ConfirmDialog
        visible={ConfirmModal}
        toggle={ConfirmToggle}
        title='Are you sure you want to delete the comment?'
        activeBtnClick={() => {
          deleteComment(deleteId);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        visible={FileSizeUploadModal}
        toggle={FileSizeUploadToggle}
        type='info'
        fileSizeInfo='fileSizeInfo'
        title='Please try uploading file size less than 5 Mb'
        activeBtnClick={() => {
          setFileSizeLimit(false);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        visible={EditTextUploadModal}
        toggle={EditTextUploadToggle}
        type='info'
        EditTextInfo='EditTextInfo'
        title="Comment Field can't be empty!!!"
        activeBtnClick={() => {
          setEditTextUpload(false);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>
    </div>
  );
};
export default CommentPage;
